import styled from "styled-components";

export const SubmitWrapper = styled.div`
    margin-top: 20px;
`;

export const TaskCard = styled.div`
    display: flex;
    align-items: center;
`;

export const TaskList = styled.div`
    margin-bottom: 16px;
    > div,
    label > div {
        display: flex;
        align-items: center;
    }

    label {
        width: 100%;
    }

    label div div {
        margin: 0 14px 0 10px;
    }
`;

export const Buttons = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    align-items: flex-end;
`;

export const ArrowButton = styled.button`
    background-color: transparent;
    border: none;
    outline: none;
    color: ${p => p.theme.c.active};
    padding: 0;
    cursor: pointer;

    &.Flip {
        transform: scale(1, -1);
    }

    &.Invisible {
        visibility: hidden;
    }
`;

export const AlreadyCreatedClassList = styled.div`
    margin-bottom: 16px;
    font-size: 14px;
    color: ${p => p.theme.c.correct};
`;
